// import Vue from 'vue';

import store from '../store/store';
import axios from 'axios';

export default {
  getAuthenticators(params) {
    const url = store.getters['auth/url'];
    const templateId = store.getters['authenticators/templateId'];
    if (params == null) {
      params = {};
    }
    params['filter.includeSubFolders'] = true;
    params['filter.secretTemplateId'] = templateId;
    params['take'] = 128;
    var urlQuery = Object.keys(params)
      .map(function (key) {
        return key + '=' + params[key];
      })
      .join('&');
    return axios.get(url + `/api/v1/secrets?` + urlQuery)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  getStub() {
    const url = store.getters['auth/url'];
    let params = {};
    params['filter.secretTemplateId'] = 9;
    params['filter.folderId'] = store.getters['authenticators/personalFolderId'];
    var urlQuery = Object.keys(params)
      .map(function (key) {
        return key + '=' + params[key];
      })
      .join('&');
    return axios.get(url + `/api/v1/secrets/stub?` + urlQuery)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  getAuthenticator(id) {
    const url = store.getters['auth/url'];
    return axios.get(url + `/api/v1/secrets/${id}`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  searchSecrets(params) {
    const url = store.getters['auth/url'];
    if (params == null) {
      params = {};
    }
    var urlQuery = Object.keys(params)
      .map(function (key) {
        return key + '=' + params[key];
      })
      .join('&');
    return axios.get(url + `/api/v1/secrets?` + urlQuery)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  getSecret(id) {
    const url = store.getters['auth/url'];
    return axios.get(url + `/api/v1/secrets/${id}`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  postSecret(payload) {
    const url = store.getters['auth/url'];
    return axios.post(url + `/api/v1/secrets`, payload)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  postSecretById(payload, id) {
    const url = store.getters['auth/url'];
    return axios.put(url + `/api/v1/secrets/` + id, payload)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  getPersonalFolders() {
    const url = store.getters['auth/url'];
    let params = {};
    params['filter.searchText'] = store.getters['auth/user'].displayName;
    params['filter.includeSubFolders'] = true;
    params.take = 1;
    var urlQuery = Object.keys(params)
      .map(function (key) {
        return key + '=' + params[key];
      })
      .join('&');
    return axios.get(url + `/api/v1/folders?` + urlQuery)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  putSecret(id, payload) {
    const url = store.getters['auth/url'];
    return axios.put(url + `/api/v1/secrets/${id}`, payload)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  getPersonalFolderId() {
    this.getPersonalFolders()
      .then(response => {
        if (typeof response.records !== 'undefined' && response.records.length >= 1) {
          let displayName = store.getters['auth/user'].displayName;
          response.records.forEach(record => {
            // Check for displayname AND "Personal Folders"
            if (record.folderName.indexOf(displayName) !== -1 && record.folderPath.indexOf("Personal Folders") !== -1) {
              store.commit('authenticators/setPersonalFolderId', record.id);
            }
          });
        }
      })
      .catch(error => Promise.reject(error.response));
  },
  getCompanyPreferences() {
    let params = {};
    let searchText = '4pa_autodiscover_';
    if (store.getters['settings/domain']) {
      searchText += store.getters['settings/domain'] + '_';
    }
    searchText += 'preferences';
    params['filter.searchText'] = searchText;
    params['filter.includeSubFolders'] = true;
    params.take = 1;
    return this.searchSecrets(params)
      .then(data => {
        if (data.total >= 1) {
          return this.getAuthenticator(data.records[0].id)
            .then(secret => {
                let authPrefs = null;
                secret.items.forEach(item => {
                  if (item.slug === 'notes') {
                    try {
                      let json = JSON.parse(item.itemValue);
                      authPrefs = json.templateId;
                    } catch (e) {
                      authPrefs = Number(item.itemValue);

                    }
                  }
                });
                if (authPrefs) {
                  store.commit('authenticators/setTemplateId', authPrefs);
                }
                store.commit('authenticators/setSettingsId', data.records[0].id);
                return 4;
              }
            );
        } else {
          return 2;
        }
        return 1;
      });
  },
  getPreferences(configure) {
    let params = {};
    let searchText = '4pa_user_';
    if (store.getters['settings/domain']) {
      searchText += store.getters['settings/domain'] + '_';
    }
    searchText += store.getters['auth/user'].userName + '_preferences';
    params['filter.searchText'] = searchText;
    params['filter.includeSubFolders'] = true;
    params.take = 1;
    return this.searchSecrets(params)
      .then(data => {
        if (data.total >= 1) {
          if (configure) {
            return this.getAuthenticator(data.records[0].id)
              .then(secret => {

                  let authPrefs = null;
                  secret.items.forEach(item => {
                    if (item.slug === 'notes') {
                      authPrefs = JSON.parse(item.itemValue);
                    }
                  });
                  if (authPrefs) {
                    store.commit('settings/setOkey', authPrefs.okey);
                    store.commit('authenticators/setFavorites', authPrefs.favorites);
                    store.commit('authenticators/setTemplateId', authPrefs.templateId);
                    store.commit('settings/setShowOtp', authPrefs.showOtp);
                  }
                  store.commit('authenticators/setSettingsId', data.records[0].id);
                  return 3;
                }
              );
          } else {
            return 2;
          }
          return 1;
        }
        return 0;
      });
  },
  postPreferences() {

    let params = {};
    let searchText = '4pa_user_';
    if (store.getters['settings/domain']) {
      searchText += store.getters['settings/domain'] + '_';
    }
    searchText += store.getters['auth/user'].userName + '_preferences';
    params['filter.searchText'] = searchText;
    params['filter.includeSubFolders'] = true;
    params.take = 1;

    return this.searchSecrets(params)
      .then(data => {
        if (data.total >= 1) {
          return this.getAuthenticator(data.records[0].id)
            .then(secret => {
              secret.items.forEach(item => {
                if (item.slug === "notes") {

                  let preferences = {
                    okey: store.getters['settings/okey'],
                    templateId: store.getters['authenticators/templateId'],
                    favorites: store.getters['authenticators/favorites'],
                    showOtp: store.getters['settings/showOtp'],
                  };
                  item.itemValue = JSON.stringify(preferences);
                }
              });

              return this.postSecretById(secret, secret.id);

            });
        } else {

          return this.getStub()
            .then(stub => {
              let name = searchText;
              let items = [];
              stub.items.forEach(item => {
                if (item.slug === "url") {
                  item.itemValue = store.getters['auth/url'];
                  items.push(item);
                }
                if (item.slug === "username") {
                  item.itemValue = "4pa_authenticators";
                  items.push(item);
                }
                if (item.slug === "password") {
                  item.itemValue = "00000000";
                  items.push(item);
                }
                if (item.slug === "notes") {
                  let preferences = {
                    okey: store.getters['settings/okey'],
                    templateId: store.getters['authenticators/templateId'],
                    favorites: store.getters['authenticators/favorites'],
                    showOtp: store.getters['settings/showOtp'],
                  };
                  item.itemValue = JSON.stringify(preferences);
                  items.push(item);
                }
              });
              let secretCreateArgs = {
                name,
                // SecretTemplate: Web password
                SecretTemplateId: 9,
                folderId: store.getters['authenticators/personalFolderId'],
                SiteId: store.getters['authenticators/siteId'],
                Items: items,
              };

              return this.postSecret(secretCreateArgs);
            });
        }
      });
  },
};



// WEBPACK FOOTER //
// ./src/services/Authenticators.js